// hooks/useUiAudio.ts
import { Howl } from 'howler'
import { useEffect, useRef } from 'react'

import click from '/sounds/sharedSounds/click.mp3'
import close from '/sounds/sharedSounds/close.mp3'
import open from '/sounds/sharedSounds/open.mp3'
import smartClick from '/sounds/sharedSounds/smart-click.mp3'
import starSound from '/sounds/sharedSounds/star-pick.mp3'
import switchOff from '/sounds/sharedSounds/switch-off.mp3'
import switchOn from '/sounds/sharedSounds/switch-on.mp3'

export const useUiAudio = () => {
  const clickRef = useRef<Howl | null>(null)
  const switchOnRef = useRef<Howl | null>(null)
  const switchOffRef = useRef<Howl | null>(null)
  const openRef = useRef<Howl | null>(null)
  const closeRef = useRef<Howl | null>(null)
  const smartClickRef = useRef<Howl | null>(null)
  const starClickRef = useRef<Howl | null>(null)

  useEffect(() => {
    clickRef.current = new Howl({ src: [click], volume: 0.3 })
    switchOnRef.current = new Howl({ src: [switchOn] })
    switchOffRef.current = new Howl({ src: [switchOff] })
    openRef.current = new Howl({ src: [open], volume: 0.3 })
    closeRef.current = new Howl({ src: [close], volume: 0.3 })
    smartClickRef.current = new Howl({
      src: [smartClick],
      volume: 0.3,
      preload: true,
    })
    starClickRef.current = new Howl({
      src: [starSound],
      volume: 0.3,
      preload: true,
    })

    return () => {
      clickRef.current?.unload()
      switchOnRef.current?.unload()
      switchOffRef.current?.unload()
      openRef.current?.unload()
      closeRef.current?.unload()
      smartClickRef.current?.unload()
      starClickRef.current?.unload()
    }
  }, [])

  return {
    playClick: () => clickRef.current?.play(),
    playSwitchOn: () => switchOnRef.current?.play(),
    playSwitchOff: () => switchOffRef.current?.play(),
    playOpen: () => openRef.current?.play(),
    playClose: () => closeRef.current?.play(),
    playSmartClick: () => smartClickRef.current?.play(),
    playStar: () => starClickRef.current?.play(),
  }
}
